export const PRODUCTION_APP_ORIGIN = "https://app.hellocashflow.com";
export const STAGING_APP_ORIGIN = "https://stagingapp.hellocashflow.com";
export const PRODUCTION_ADMIN_ORIGIN = "https://admin.hellocashflow.com";
export const STAGING_ADMIN_ORIGIN = "https://stagingadmin.hellocashflow.com";

/** Open synthetic Demo data without minting a customer or staff spoof session. */
export const getDemoCompanyEntryUrl = (adminOrigin: string): string => {
  // Only the canonical production Admin may send staff to the production app.
  // Local, preview, staging and unrecognised hosts use the staging destination.
  const appOrigin =
    adminOrigin === PRODUCTION_ADMIN_ORIGIN
      ? PRODUCTION_APP_ORIGIN
      : STAGING_APP_ORIGIN;
  return `${appOrigin}/login?demoCompany=1`;
};

/**
 * Production Admin writes View-as sessions to the production database only, so
 * the staging app can never resolve them. Unknown hosts keep the staging link.
 */
export const canAdminLaunchStagingAppSession = (adminOrigin: string): boolean =>
  adminOrigin !== PRODUCTION_ADMIN_ORIGIN;
